<template>
  <div>
    <TopMenu/>
    <div class="view">
      <transition name="fade" appear>
        <div>
          <div class="p-4">{{$t('Menu')}}</div>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" :to="ROUTE_DASHBOARD">
            <FontAwesomeIcon class='text-primary mr-2' icon="music"/>
            {{$t('Now Playing')}}
          </router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" to="/playlists">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'list-alt']"/>
            {{$t('Playlists')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" to="/playlist-schedule">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'clock']"/>
            {{$t('Playlist Schedule')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" :to="ROUTE_JINGLES">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'bullhorn']"/>
            {{$t('Jingles')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" :to="ROUTE_JINGLE_SCHEDULE">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'calendar-alt']"/>
            {{$t('Jingle Schedule')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" :to="ROUTE_JUKEBOX">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'bullseye']"/>
            {{$t('Jukebox')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" :to="ROUTE_REPORTS">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'chart-bar']"/>
            {{$t('Reports')}}</router-link>
          <router-link class="d-block bg-dark px-4 py-3 text-muted" to="/help">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['far', 'question-circle']"/>
            {{$t('Help')}}</router-link>
          <a class="d-block bg-dark px-4 py-3 text-muted" href="#" v-on:click="logout($event)">
            <FontAwesomeIcon class='text-primary mr-2' :icon="['fas', 'sign-out-alt']"/>
            {{$t('Sign Out')}}</a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { ROUTE_DASHBOARD, ROUTE_LOGIN, ROUTE_JINGLES, ROUTE_JINGLE_SCHEDULE, ROUTE_JUKEBOX, ROUTE_REPORTS } from '@/const/routeNames'
import localStorageUtil from '@/utils/localStorageUtil'
import audioManager from '@/utils/audioManager'

export default {

  name: 'Menu',

  data () {
    return {
      ROUTE_DASHBOARD,
      ROUTE_JINGLES,
      ROUTE_JINGLE_SCHEDULE,
      ROUTE_JUKEBOX,
      ROUTE_REPORTS
    }
  },

  methods: {
    logout (e) {
      e.preventDefault()
      localStorageUtil.removeToken()
      localStorageUtil.removeUserEmail()
      localStorageUtil.removeUserProvider()
      localStorageUtil.removeSubscribeLink()
      audioManager.pause()
      this.$store.commit('setAuthorized', false)
      this.$store.commit('setUserEmail', null)
      this.$store.commit('setUserProvider', null)
      this.$router.push(ROUTE_LOGIN)
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue